import React, { useEffect, useState } from "react";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Space from "../ui/Space";
import VirtualTable from "../ui/VirtualTable";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import { InfoIcon, SortIcon } from "../utils/Icons";
import Label from "../ui/Label";
import Nav from "../ui/Nav";
import { createModal } from "../hooks/createModal";
import SetupTaxCodesNew from "./SetupTaxCodesNew";
import { getAdjacent, kbdEvent, showConfirm } from "../utils/Utils";
import Confirm from "./Confirm";
import SetupTaxCodesSearch from "./SetupTaxCodesSearch";
import TextButton from "../ui/TextButton";
import SetupTaxTypesNew from "./SetupTaxTypesNew";

export default function SetupTaxCodes(props) {

    const { controller = "", value = "", callback = () => { }, route = "", modal = false, returnObj = false } = props;

    const [groups, setGroups] = useState([]);
    const [types, setTypes] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState({})
    const [selectedType, setSelectedType] = useState({});
    const [left, setLeft] = useState(true);

    const [filters, setFilters] = useState({
        sort: "customer_code",
        search: ""
    })

    const groups_nav = [
        { key: KBD.D, text: "Del", action: () => deleteGroup() },
        { key: KBD.E, text: "Edt", action: () => drawEditGroup() },
        { key: KBD.I, text: "Indx", action: () => { (filters.sort === "customer_code") ? setFilters({ ...filters, "sort": "description" }) : setFilters({ ...filters, "sort": "customer_code" }); } },
        { key: KBD.N, text: "New", action: () => drawNewGroup() },
        { key: KBD.S, text: "Srch", action: () => drawSearch() }
    ]

    const types_nav = [
        { key: KBD.N, text: "New", action: () => drawNewType() },
        { key: KBD.E, text: "Edt", action: () => drawEditType() },
        { key: KBD.D, text: "Del", action: () => deleteType() },
    ]

    useEffect(() => {
        const actions = [

            { key: KBD.ESCAPE, action: (e) => { callback(false) } },
            { key: KBD.ARROW_LEFT, action: (e) => { switchSide(true) } },
            { key: KBD.ARROW_RIGHT, action: (e) => { switchSide(false) } },
        ];
        const cleanup = listen(controller, ROUTES.GLOBAL.SETUP_TAXCODES_RIGHT, actions.concat(types_nav), false);
        return cleanup;
    }, [left, types_nav]);

    useEffect(() => {
        const actions = [
            { key: KBD.ENTER, action: (e) => { if (returnObj) { callback(selectedGroup) } } },
            { key: KBD.ESCAPE, action: (e) => { callback(false) } },
            { key: KBD.ARROW_LEFT, action: (e) => { switchSide(true) } },
            { key: KBD.ARROW_RIGHT, action: (e) => { switchSide(false) } },
        ];
        const cleanup = listen(controller, route, actions.concat(groups_nav), false);
        return cleanup;
    }, [left, groups_nav]);


    const search = (value, customers = []) => {
        if (!value || !customers.length) return null;

        const term = value.trim().toLowerCase();

        let index = customers.findIndex(item =>
            item.customer_code?.toLowerCase() === term
        );

        if (index === -1) {
            index = customers.findIndex(item =>
                item.customer_code?.toLowerCase().startsWith(term)
            );
        }

        if (index === -1) {
            index = customers.findIndex(item =>
                item.customer_code?.toLowerCase().includes(term)
            );
        }

        return index === -1 ? 0 : index;
    };


    const fetchAll = () => {
        pubCall("setting.tax.getAll", {}, (_s, _r) => {
            if (_s) {
                const _find = search(value, _r.groups)
                setGroups(_r.groups);
                setSelectedGroup(_r.groups[_find])
                setTypes(_r.types);
                setSelectedType(_r.types[_find]);
            } else {
                showError(_r);
            }
        })
    }
    useEffect(fetchAll, []);

    const next = (_rows = 1) => {
        const _groups = filterGroups();
        if (_groups.length === 0) { setSelectedGroup({}); return; }
        const currentIndex = _groups.findIndex(item => item?.customer_code === selectedGroup?.customer_code);
        const nextIndex = Math.min(currentIndex + _rows, _groups.length - 1);
        setSelectedGroup(_groups[nextIndex]);
    };

    const prev = (_rows = 1) => {
        const _groups = filterGroups();
        if (_groups.length === 0) { setSelectedGroup({}); return; }
        const currentIndex = _groups.findIndex(item => item?.customer_code === selectedGroup?.customer_code);
        const prevIndex = Math.max(currentIndex - _rows, 0);
        setSelectedGroup(_groups[prevIndex]);
    };

    const nextType = (_rows = 1) => {
        if (types.length === 0) { setSelectedType({}); return; }
        const currentIndex = types.findIndex(item => item?.code === selectedType?.code);
        const nextIndex = Math.min(currentIndex + _rows, types.length - 1);
        setSelectedType(types[nextIndex]);
    };

    const prevType = (_rows = 1) => {
        if (types.length === 0) { setSelectedType({}); return; }
        const currentIndex = types.findIndex(item => item?.code === selectedType?.code);
        const prevIndex = Math.max(currentIndex - _rows, 0);
        setSelectedType(types[prevIndex]);
    };

    const colSort = (_text, _key) => {
        const match = (filters.sort === _key);
        if (!match) {
            return (<div onClick={() => setFilters({ ...filters, "sort": _key })} className="ui-col-sort">{_text} &nbsp;<SortIcon />&nbsp;</div>)
        } else {
            return (<div className="ui-col-sort active">{_text} &nbsp;<SortIcon />&nbsp;</div>)
        }
    }

    const tax_codes = [
        { key: "code", align: "center", title: <>Code</>, width: 45 },
        { key: "gl_account", align: "left", title: <>Account</>, width: 65 },
        { key: "gl_description", align: "left", title: <>Description</>, width: 210, grow: true },
        { key: "name", align: "left", title: <>Name</>, width: 50 },
        { key: "points_coupons", align: "center", title: <>Points</>, width: 60 },
        { key: "rate", align: "right", title: <>Rate </>, width: 44 },
    ]

    const tax_groups = [
        { key: "customer_code", align: "left", title: colSort("Code", "customer_code"), width: 60 },
        { key: "description", align: "left", title: colSort("Description", "description"), width: 195, grow: true },
        { key: "tax_code_1", align: "center", title: <>1</>, width: 30 },
        { key: "tax_code_2", align: "center", title: <>2</>, width: 30 },
        { key: "tax_code_b", align: "center", title: <>B</>, width: 30 },
        { key: "tax_code_3", align: "center", title: <>3</>, width: 30 },
    ]

    const switchSide = (_left = false) => {

        if (left === _left) {
            // nothing changes..
            return;
        }

        if (_left) {
            window.bm_state.value = route;
            setLeft(true);
        } else {
            window.bm_state.value = ROUTES.GLOBAL.SETUP_TAXCODES_RIGHT;
            setLeft(false);
        }
    }

    const drawSearch = () => {
        window.bm_state.value = ROUTES.GLOBAL.SETUP_TAXCODES_SEARCH;
        createModal({
            component: <SetupTaxCodesSearch controller={controller} groups={groups} types={types} route={ROUTES.GLOBAL.SETUP_TAXCODES_SEARCH} />, title: "Filter list of tax codes", closable: true, callback: (e) => {
                if (e) {
                    let _arr = filterGroups(e);
                    if (_arr.length > 0) {
                        setFilters({ ...filters, search: e });
                        setSelectedGroup(_arr[0]);
                    } else {
                        setFilters({ ...filters, search: "" });
                    }
                } else {
                    setFilters({ ...filters, search: "" });
                }
                window.bm_state.value = route;
            }
        })
    }

    const deleteType = () => {
        showConfirm({
            controller: controller,
            route: window.bm_state.value, title: "Delete?", description: <div style={{ "textAlign": "center" }}>Delete this entry?</div>,
            callback: (_key) => {
                if (_key) {
                    pubCall("setting.tax.deleteType", { code: selectedType?.code }, (_s, _r) => {
                        if (_s) {
                            setSelectedType(getAdjacent(types, { ...selectedType }, "code", {}));
                            setTypes([...types].filter(item => item.code !== selectedType?.code));
                            showMessage("Tax type deleted")
                        } else {
                            showError(_r);
                        }
                    })
                }
            }
        })
    }

    const deleteGroup = () => {
        showConfirm({
            controller: controller,
            route: window.bm_state.value, title: "Delete?", description: <div style={{ "textAlign": "center" }}>Delete this entry?</div>,
            callback: (_key) => {
                if (_key) {
                    pubCall("setting.tax.deleteGroup", { code: selectedGroup?.customer_code }, (_s, _r) => {
                        if (_s) {
                            setSelectedGroup(getAdjacent(filterGroups(), { ...selectedGroup }, "customer_code", {}));
                            setGroups([...groups].filter(item => item.customer_code !== selectedGroup.customer_code));
                            showMessage("Customer tax code deleted")
                        } else {
                            showError(_r);
                        }
                    })
                }
            }
        })
    }

    const drawNewGroup = () => {
        window.bm_state.value = ROUTES.GLOBAL.SETUP_TAXCODES_NEW;
        createModal({
            component: <SetupTaxCodesNew controller={controller} groups={groups} types={types} route={ROUTES.GLOBAL.SETUP_TAXCODES_NEW} />, title: "New Tax Group", closable: true, callback: (e) => {
                if (e) {
                    let _arr = [...groups].concat([e]);
                    setGroups(_arr);
                    setSelectedGroup(e);
                    showMessage("Customer tax code added")
                }
                window.bm_state.value = route;
            }
        })
    }

    const drawNewType = () => {
        window.bm_state.value = ROUTES.GLOBAL.SETUP_TAXTYPES_NEW_TYPE;
        createModal({
            component: <SetupTaxTypesNew controller={controller} groups={groups} types={types} route={ROUTES.GLOBAL.SETUP_TAXTYPES_NEW_TYPE} />, title: "New Tax Type", closable: true, callback: (e) => {
                if (e) {
                    setTypes([...types].concat([e]));
                    setSelectedType(e);
                }
                window.bm_state.value = ROUTES.GLOBAL.SETUP_TAXCODES_RIGHT;
            }
        })
    }

    const drawEditType = () => {
        window.bm_state.value = ROUTES.GLOBAL.SETUP_TAXTYPES_NEW_TYPE;
        createModal({
            component: <SetupTaxTypesNew controller={controller} edit={true} type={selectedType} groups={groups} types={types} route={ROUTES.GLOBAL.SETUP_TAXTYPES_NEW_TYPE} />, title: "New Tax Type", closable: true, callback: (e) => {
                if (e) {
                    let _types = [...types];
                    let _ind = _types.findIndex(item => item.code === selectedType?.code);
                    _types[_ind] = e;
                    setTypes(_types);
                    setSelectedType(e);
                    showMessage("Tax type updated")
                }
                window.bm_state.value = ROUTES.GLOBAL.SETUP_TAXCODES_RIGHT;
            }
        })
    }

    const drawEditGroup = () => {
        window.bm_state.value = ROUTES.GLOBAL.SETUP_TAXCODES_NEW;
        createModal({
            component: <SetupTaxCodesNew controller={controller} edit={true} groups={groups} group={selectedGroup} types={types} route={ROUTES.GLOBAL.SETUP_TAXCODES_NEW} />, title: "New Tax Group", closable: true, callback: (e) => {
                if (e) {
                    let _groups = [...groups];
                    let _ind = _groups.findIndex(item => item.customer_code === selectedGroup?.customer_code);
                    _groups[_ind] = e;
                    setGroups(_groups);
                    setSelectedGroup(e);
                    showMessage("Customer tax code updated")
                }
                window.bm_state.value = route;
            }
        })
    }

    const filterGroups = (_s = filters.search) => {
        return groups.filter((item) => {
            if (_s) {
                if (item.description.includes(_s)) {
                    return true;
                } else {
                    return false;
                }
            }
            return true;
        }).sort((a, b) => {
            if (a[filters.sort] < b[filters.sort]) {
                return -1;
            }
            if (a[filters.sort] > b[filters.sort]) {
                return 1;
            }
        });
    }

    const draw = () => {
        return (
            <div style={{ "padding": (modal) ? "0px" : "0px 5px", "paddingBottom": (modal) ? "0px" : "5px" }}>
                <div className="shim" /><div className="shim" /><div className="shim" />
                <Space>
                    <div style={{ "opacity": (!left) ? "0.7" : "1" }} onClick={() => switchSide(true)}>
                        <VirtualTable
                            controller={controller}

                            header={<Label style={{ "textAlign": "left" }}>Customer tax codes</Label>}
                            row_key={"customer_code"}
                            next={next}
                            prev={prev}
                            onRowDoubleClick={(e) => callback(e)}
                            tweak={60}
                            route={route}
                            current={selectedGroup}
                            data={filterGroups()}
                            width={410}
                            height={388}
                            offset={0}
                            columns={tax_groups}
                            onRowClick={(item, event, index) => setSelectedGroup(item)}
                        />
                        <div className="shim" />
                        <div style={{ "height": "20px", "marginBottom": "-5px" }}>{(left && <Nav nav={groups_nav} />)}</div>
                    </div>
                    <div style={{ "opacity": (left) ? "0.7" : "1" }} onClick={() => switchSide(false)}>
                        <VirtualTable
                            controller={controller}
                            header={<Label style={{ "textAlign": "left" }}>Tax types, names and rates </Label>}
                            row_key={"code"}
                            next={nextType}
                            prev={prevType}
                            tweak={60}
                            onRowClick={(item) => setSelectedType(item)}
                            // onRowDoubleClick={(item) => { callback(item); }}
                            route={ROUTES.GLOBAL.SETUP_TAXCODES_RIGHT}
                            current={selectedType}
                            data={types}
                            width={500}
                            height={388}
                            offset={0}
                            columns={tax_codes}
                        />
                        <div className="shim" />
                        <div style={{ "height": "20px", "marginBottom": "-5px" }}>{(!left && <Nav nav={types_nav} />)}</div>
                    </div>
                </Space>
            </div>
        )
    }

    return draw()
}

